/**
 * 数字正则
 */
export const NUMBER_REG = /^-?\d*(\.\d*)?$/;

/**
 * 大于0的整数或者空字符串正则
 */
export const INTEGER_REG = /^([1-9]\d*|0)?$/;

/**
 * 保留2位小数或者空字符串正则
 */
export const FLOAT_TWO_REG = /^(([1-9]\d*)|0)?(\.\d{0,2})?$/;

/**
 * 保留4位小数或者空字符串正则
 */
export const FLOAT_FOUR_REG = /^(([1-9]\d*)|0)?(\.\d{0,4})?$/;

/**
 * 数字或者千分位数字正则
 */
export const NUMBER_THOUSANDS_REG = /^-?\d{1,3}(,\d{3})*(\.\d*)?$/;

/**
 * 6-20位字母/数字/符号至少两种组合正则
 */
export const PASSWORD_REG =
  /^(?![0-9]+$)(?![a-zA-Z]+$)(?![\!@#\$%\^&\*\-_\\\.~]+$)[0-9A-Za-z\!@#\$%\^&\*\-_\\\.~]{6,20}$/;

/**
 * 字母/数字/符号至少两种组合正则
 */
export const PASSWORD_REG_TWO =
  /^(?![0-9]+$)(?![a-zA-Z]+$)(?![\!@#\$%\^&\*\-_\\\.~]+$)[0-9A-Za-z\!@#\$%\^&\*\-_\\\.~]{1,}$/;

/**
 * 小于等于100的2位的数字正则
 */
export const NUMBER_100_REG = /^([0-9]|[1-9][0-9]|100)?(\.\d{0,2})?$/;
